export const lineBreakToBR = (str: string | null): string => {
  if (!str) { return ''; }

  return str
    .replace(/\r\n|\\r\\n/g, '<br>')
    .replace(/\r|\\r/g, '<br>')
    .replace(/\n|\\n/g, '<br>');
};

export const splitByLineBreak = (str: string | null): string[] => {
  if (!str) { return []; }
  const token = '#@%;#';
  return str
    .replace(/\r\n|\\r\\n/g, token)
    .replace(/\r|\\r/g, token)
    .replace(/\n|\\n/g, token)
    .split(token);
};

// pagerの現在ページに該当する範囲の要素を返す
export const paginateItems = <T>(
  items: T[],
  pager: { currentPage: number; itemsPerPage: number },
): T[] => {
  const nextPageIdx = pager.currentPage * pager.itemsPerPage;
  const minIdx = nextPageIdx - pager.itemsPerPage;
  return items.slice(minIdx, nextPageIdx);
};
